import React from "react";
import PropTypes from "prop-types";
import { Alert, Card, Table, Tag } from "antd";

import { formatAmount, formatDate, purchaseStage } from "../../../constants/marketplaceCheckout";
import { productLabel, transactionAmount } from "../../../hooks/useMyTransactions";

/** Tableau des ventes ou des achats de l'utilisateur, avec leur nombre en titre (0 si aucune). */
const TransactionTable = ({ title, transactions, loading, error, userId, emptyText, counterpartTitle }) => {

    const columns = [
        { title: "Date", key: "date", render: (_, row) => formatDate(row.createdAt) },
        { title: "Produit", key: "product", render: (_, row) => productLabel(row) },
        counterpartTitle && {
            title: counterpartTitle,
            key: "counterpart",
            render: (_, row) => row.sellerCompanyName || "—"
        },
        {
            title: "Montant",
            key: "amount",
            align: "right",
            render: (_, row) => formatAmount(transactionAmount(row), row.currency)
        },
        {
            title: "Statut",
            key: "status",
            render: (_, row) => {
                const stage = purchaseStage(row, userId);
                return <Tag color={stage.color}>{stage.label}</Tag>;
            }
        }
    ].filter(Boolean);

    return (
        <Card title={`${title} (${loading ? "…" : transactions.length})`}>
            {error && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 16 }}
                    title="Impossible de charger vos transactions pour le moment."
                />
            )}
            <Table
                rowKey="agreementId"
                columns={columns}
                dataSource={transactions}
                loading={loading}
                locale={{ emptyText }}
                pagination={{ pageSize: 10, hideOnSinglePage: true }}
                scroll={{ x: true }}
            />
        </Card>
    );
};

TransactionTable.propTypes = {
    title: PropTypes.string.isRequired,
    transactions: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    userId: PropTypes.string,
    emptyText: PropTypes.string.isRequired,
    counterpartTitle: PropTypes.string
};

export default TransactionTable;
